import { makeStyles, createStyles } from "@material-ui/core/styles";

export default makeStyles((theme) =>
  createStyles({
    card: {
      boxShadow: "0px 0px 25px rgba(0, 0, 0, 0.1)",
      borderRadius: "6px",
      width: "264px",
      [theme.breakpoints.only("xs")]: {
        width: "319px",
      },
      "&:hover": {
        background: "white",
        cursor: "pointer",
        boxShadow: "2px 2px 6px 3px rgb(0 0 0 / 21%)",
        "& .MuiCardMedia-root": {
          backgroundColor: "#00000080",
          backgroundBlendMode: "color",
          transition: "background-color 0.25s",
          "&, &:after": {
            content: "'View More >'",
            fontFamily: "Inter",
            fontSize: theme.typography.pxToRem(14),
            fontWeight: 600,
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
        },
      },
    },
    media: {
      height: "144px",
      [theme.breakpoints.only("xs")]: {
        height: "161px",
      },
    },
    content: {
      padding: "24px 16px",
      [theme.breakpoints.only("xs")]: {
        padding: "16px",
      },
    },
    categoryCreatedContainer: {
      display: "flex",
      justifyContent: "space-between",
      height: "16px",
      margin: "0 0 21px 0",
      fontFamily: "Lato",
      fontWeight: 400,
      fill: "#747F9D",
      color: "#747F9D",
      [theme.breakpoints.only("xs")]: {
        height: "24px",
        margin: "0 0 9px 0",
      },
    },
    category: {
      fontSize: theme.typography.pxToRem(14),
      [theme.breakpoints.only("xs")]: {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    created: {
      fontSize: theme.typography.pxToRem(12),
      [theme.breakpoints.only("xs")]: {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    title: {
      height: "40px",
      fontFamily: "Lato",
      fontSize: theme.typography.pxToRem(16),
      lineHeight: "19px",
      margin: "0 0 11px 0",
      overflow: "hidden",
      [theme.breakpoints.only("xs")]: {
        fontWeight: 400,
        fontSize: theme.typography.pxToRem(16),
        height: "48px",
        margin: "0 0 31px 0",
      },
    },
    resourceTimeContainer: {
      display: "flex",
      flexDirection: "column",
      [theme.breakpoints.only("xs")]: {
        flexDirection: "row",
        margin: "0",
        height: "24px",
      },
    },
    resourceType: {
      display: "flex",
      alignItems: "center",
      height: "14px",
      fontFamily: "Lato",
      fontWeight: 400,
      margin: "0 0 26px 0",
      fontSize: theme.typography.pxToRem(12),
      fill: "#747F9D",
      color: "#747F9D",
      [theme.breakpoints.only("xs")]: {
        fontSize: theme.typography.pxToRem(14),
        marginRight: theme.spacing(2),
      },
    },
    time: {
      display: "flex",
      alignItems: "center",
      height: "16px",
      margin: "0",
      fontFamily: "Lato",
      fontWeight: 400,
      fontSize: theme.typography.pxToRem(14),
      fill: "#45547C",
      color: "#45547C",
      justifyContent: "space-between",
      [theme.breakpoints.only("xs")]: {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    icon: {
      fontSize: "1rem",
      marginRight: theme.spacing(0.5),
    },
  })
);
